export const ORDERBOOK_LOADING = 'ORDERBOOK_LOADING';
export const ORDERBOOK_ERROR = 'ORDERBOOK_ERROR';
export const ORDERBOOK_SUCCESS = 'ORDERBOOK_SUCCESS';
export const ORDERBOOK_DROP_ERROR = 'ORDERBOOK_DROP_ERROR';